import React, { FC } from 'react';
import OrganizationModal from 'shared/components/OrganizationModal';
import WarningIcon from 'assets//ColorIcons/PNG/warning_alert.png';
import COButton from 'shared/components/COButton';
import styles from './isCompletedModal.module.scss';

interface IsCompletedModalProps {
  isModalOpen: boolean;
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  deleteLocation?: (locationId?: number | undefined) => Promise<void>;
}

const IsCompletedModal: FC<IsCompletedModalProps> = ({
  isModalOpen,
  setIsModalOpen,
}) => {
  const handleClose = () => setIsModalOpen?.(false);
  return (
    <OrganizationModal
      visible={isModalOpen}
      onClose={handleClose}
      children={
        <div className={styles.alertContainer}>
          <div className={styles.alertIconContainer}>
            <img src={WarningIcon} />
          </div>
          <div className={styles.alertTextContainer}>
            Complete Scope 1 and Scope 2 data for at least one year before
            proceeding
          </div>
          <div className={styles.alertButtonContainer}>
            <COButton primary children="Go back" onClick={handleClose} />
          </div>
        </div>
      }
    />
  );
};

export default IsCompletedModal;
